import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import Admin from "@/pages/Admin";

function App() {
  return (
    <ReactLenis root options={{ anchors: true, lerp: 0.09 }}>
      <div className="App bg-cream text-ink">
        <div className="grain-overlay" aria-hidden="true" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<Article />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
